import React from "react";
import 'react-dates/lib/css/_datepicker.css';
import {DayPickerRangeController, DateRangePicker} from 'react-dates';
import styles from "../StyleComponents/index.js";
let {DatePicker} = styles.datePicker;
export const DateRangePickerComponent = (props) => {
        return (<DatePicker>
            {props.isInputRequired ? <DateRangePicker className="date-range-picker" {...props} /> : <DayPickerRangeController {...props} />}
        </DatePicker>)
}